const MIN_FILES_TO_SHOW_UPLOADER = 2;
const FILESIZE_THRESHOLD_TO_FORCE_SHOW_UPLOADER = 3e7;

export { FILESIZE_THRESHOLD_TO_FORCE_SHOW_UPLOADER, MIN_FILES_TO_SHOW_UPLOADER };
//# sourceMappingURL=bulkUploader.constants.js.map
